<template>
	<div>
		<div class="px-3"> <!-- Mustafijur: 24-08-2026 -->
            <div class="row no-gutters py-2 mb-3">
                <div class="col-sm-6 pr-3 ">
                    <h4 class="atlhr-dashboard-title mt-10">
                        <span class="blue-title">GF</span> Summery
                        <span>
                            <a v-bind:href="pageurl">Dashboard</a>
                            / GF Summery
                        </span>
                    </h4>
                </div>
            </div> 
			<div class="row">                
                <div class="row col-12 no-margin">
                    <div class="ibox col-md-12 border-0">
                        <div class="ibox-title dashboard_title">
                            <h4 class="clearfix">
                                <span class="float-left">Gratuity Fund Summary<span class="title-sub-text">A comprehensive overview of potential gratuity amount to be received till date:</span></span>
                                <span class="float-right"></span>
                            </h4>
                        </div>
                        <div class="ibox-content">
                            
                            <template>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 cursor-pointer">
                                        <table class="w-100">
                                            <thead>
                                                <tr class="table-head">
                                                    <th scope="col">Particulars</th>
                                                    <th class="text-right" scope="col">Details</th>													
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template>
                                                    <tr class="table-row">
                                                        <td class="font-semi-bold">Joining date</td>
                                                        <!-- {{ summaryData }} -->
                                                        <td class="text-right font-semi-bold">{{ summaryData.joining_date }}</td>														
                                                    </tr>
                                                    <tr class="table-row" v-if="summaryData.last_working_date">
                                                        <td>Last working date</td>
                                                        <td class="text-right">{{ summaryData.last_working_date }}</td>
                                                    </tr>
                                                    <tr v-else class="table-row"><!-- Mustafijur: 24-08-2026 -->
                                                        <td>Today's date</td>
                                                        <td class="text-right">{{ summaryData.today_date }}</td>
                                                    </tr>
                                                    <tr class="table-row">
                                                        <td>Lenght of service in years</td>
                                                        <td class="text-right">{{ summaryData.length_of_service_years }}</td>														
                                                    </tr>
                                                    <tr class="table-row">
                                                        <td>Eligible length of service in years</td>
                                                        <td class="text-right">{{ summaryData.eligible_length_of_service_years }}</td>														
                                                    </tr>
                                                    <tr class="table-row">
                                                        <td class="font-semi-bold">Latest Basic Salary</td>
                                                        <td class="text-right font-semi-bold">{{ summaryData.latest_basic_salary }}</td>														
                                                    </tr>
                                                    <tr class="table-row">
                                                        <td class="font-semi-bold">Potential GF Balance</td>
                                                        <td class="text-right font-semi-bold">{{ summaryData.potential_gf_balance }}</td>														
                                                    </tr>
                                                </template>
                                                
                                                                            
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </template>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
 export default{    
    data() {
        return {
            showoverlay : true,
            summaryData: null,
        }
    },
    methods:{
        
        showContent: function()
        {
            this.showoverlay = false;
        },

        getGfSummery() {
            let currentObj = this;
            currentObj.showoverlay = true;

            axios.get(this.$api_url_front + '/gf/employee-gf-summary')
            .then(function(response) {
                currentObj.summaryData = response.data;
                currentObj.showoverlay = false;
            })
            .catch(function(error) {
                currentObj.serverError(error);
                currentObj.showoverlay = false;
            });
        },
    },
    created: function(){
        this.getGfSummery();
    }

}
</script>
